<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        แก้ไขรายการส่งเสริมการขายอินเทอร์เน็ตความเร็วสูงประจำที่
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการข้อมูลอินเทอร์เน็ตประจำที่
          </a>
        </li>
        <li class="active">แก้ไขรายการส่งเสริมการขายอินเทอร์เน็ตประจำที่</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header with-border">
                <h3 class="box-title">จัดการ</h3>
              </div>

              <div class="row">
                <div class="col-sm-12">
                  <div class="layout_step_internet">
                    <el-steps
                      :active="active"
                      finish-status="success"
                      simple
                      style="margin-top: 19px"
                    >
                      <el-step title="ขั้นตอนที่ 1" class="btn-step" @click.native="steps(0)"></el-step>
                      <el-step title="ขั้นตอนที่ 2" class="btn-step" @click.native="steps(1)"></el-step>
                      <el-step title="ขั้นตอนที่ 3" class="btn-step" @click.native="steps(2)"></el-step>
                      <el-step title="ขั้นตอนที่ 4" class="btn-step" @click.native="steps(3)"></el-step>
                      <el-step title="ขั้นตอนที่ 5" class="btn-step" @click.native="steps(4)"></el-step>
                    </el-steps>
                  </div>
                </div>
                <div class="col-sm-12">
                  <!-- <el-col :span="16" :offset="4"> -->
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="100px"
                      :model="form"
                      ref="ruleForm"
                    >
                      <el-form size="small" v-if="active===0" class='col-sm-12'>
                        <el-form-item label="รหัสรายการส่งเสริมการขาย"  required>
                          <el-input maxlength="20" clearable v-model="form.promotion_code"></el-input>
                        </el-form-item>
                        <el-form-item label="ชื่อรายการเสริมการขาย (ภาษาไทย)"  required>
                          <el-input show-word-limit maxlength="200" clearable v-model="form.promotion_name_th"></el-input>
                        </el-form-item>
                        <el-form-item label="ชื่อรายการเสริมการขาย (ภาษาอังกฤษ)" >
                          <el-input show-word-limit maxlength="200" clearable v-model="form.promotion_name_en"></el-input>
                        </el-form-item>
                        <el-form-item label="ประเภทเทคโนโลยีของการให้บริการ" required>
                          <el-select v-model="form.promotion_technology" filterable>
                            <el-option value="FTTx">FTTx</el-option>
                            <el-option value="VDSL">VDSL</el-option>
                            <el-option value="ADSL">ADSL</el-option>
                            <el-option value="WiFi">WiFi</el-option>
                            <el-option value="VAS">VAS</el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="ชนิดของรายการส่งเสริมการขาย" required>
                          <el-select v-model="form.promotion_type">
                            <el-option value="main" label="รายการส่งเสริมการขายหลัก (Main)"></el-option>
                            <el-option value="on-top" label="รายการส่งเสริมการขายเสริม (On top)"></el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item label="ระยะเวลา"></el-form-item>
                        <div class="row">
                          <div class="col-sm-6">
                            <el-form-item label="เริ่มต้นของการเสนอขาย" required>
                              <el-date-picker v-model="form.start_sale_date" type="date" placeholder="เลือกวันที่">
                              </el-date-picker>
                            </el-form-item>
                          </div>
                          <div class="col-sm-6">
                            <el-form-item label="สิ้นสุดของการเสนอขาย">
                              <el-date-picker v-model="form.end_sale_date" type="date" placeholder="เลือกวันที่">
                              </el-date-picker>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <el-form-item label="เริ่มต้นของการให้บริการ" required>
                              <el-date-picker v-model="form.start_service_date" type="date" placeholder="เลือกวันที่">
                              </el-date-picker>
                            </el-form-item>
                          </div>
                          <div class="col-sm-6">
                            <el-form-item label="สิ้นสุดของการให้บริการ">
                              <el-date-picker v-model="form.end_service_date" type="date" placeholder="เลือกวันที่">
                              </el-date-picker>
                            </el-form-item>
                          </div>
                        </div>
                        <el-form-item label="สถานะการให้บริการ" required>
                          <el-select v-model="form.service_status" style="width:220px;">
                            <el-option label="(S) เฉพาะรายการส่งเสริมการขายใหม่ (ยังขายอยู่)" value="s"></el-option>
                            <el-option label="(U) ไม่ขายแล้วแต่ยังให้บริการอยู่" value="u"></el-option>
                            <el-option label="(X) ยกเลิกการให้บริการแล้ว" value="x"></el-option>
                            <el-option label="(CS) Corporate (ยังขายอยู่)" value="cs"></el-option>
                            <el-option label="(CU) Corporate (ไม่ขายแล้วแต่ยังให้บริการอยู่)" value="cu"></el-option>
                            <el-option label="(CX) Corporate (ยกเลิกการให้บริการแล้ว)" value="cx"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="ค่าบริการรายเดือน (บาท)" :required="form.promotion_type == 'main'" >
                          <el-input-number v-model="form.promotion_price" :precision="2" :step="10"  :max="999999999" :min="null" style="width: 220px"></el-input-number>
                        </el-form-item>
                      <div class="col-xs-12" style="padding-bottom: 20px !important">
                        <div class="col-xs-3"></div>
                        <div class="col-xs-2"> </div>
                        <div class="col-xs-2">
                          <el-button
                            type="success"
                            @click="preview()"
                            >
                            บันทึก
                          </el-button>
                        </div>
                        <div class="col-xs-2"></div>
                        <div class="col-xs-3">
                          <el-button round
                            type="primary"
                            class="pull-right"
                            @click="next()"
                            >
                            <i class="el-icon-right"></i>
                          </el-button>
                        </div>
                      </div>
                      </el-form>

                      <el-form size="small" v-if="active===1" class='col-sm-12'>
                        <el-form-item label="สิทธิการใช้งานที่ผู้ใช้บริการได้รับจำแนกตามประเภทบริการ"></el-form-item>
                        <el-form-item label="บริการ Internet" prop="voice_service">
                          </el-form-item>
                        <div class="row">
                          <div class="col-sm-6">
                          <el-form-item label="ความเร็วดาวน์โหลด (Mbps)" prop="download_speed" :required="form.promotion_type == 'main'">
                            <el-input-number v-model="form.download_speed" :precision="3" :step="10" :min="null" :max="99999" style="width: 240px"></el-input-number>
                          </el-form-item>
                          </div>
                          <div class="col-sm-6">
                            <el-form-item label="ความเร็วอัปโหลด (Mbps)" prop="upload_speed" :required="form.promotion_type == 'main'">
                              <el-input-number v-model="form.upload_speed" :precision="3" :step="10" :min="null" :max="99999" style="width: 240px"></el-input-number>
                            </el-form-item>
                          </div>
                        </div>
                        <p>*หากเลือกชนิดของรายการส่งเสริมการขายเป็น "รายการส่งเสริมการขายหลัก(main)"</p>
                        <p>กรุณากรอกความเร็วดาวน์โหลด และความเร็วอัปโหลด</p>
                        <div class="col-xs-12" style="padding-bottom: 20px !important">
                          <div class="col-xs-3">
                            <el-button round
                              type="primary"
                              class="pull-left"
                              @click="back()"
                            >
                              <i class="el-icon-back"></i>
                            </el-button>
                          </div>
                          <div class="col-xs-2"> </div>
                          <div class="col-xs-2">
                            <el-button
                              type="success"
                              @click="preview()"
                              >
                              บันทึก
                            </el-button>
                          </div>
                          <div class="col-xs-2"></div>
                          <div class="col-xs-3">
                            <el-button round
                              type="primary"
                              class="pull-right"
                              @click="next()"
                              >
                              <i class="el-icon-right"></i>
                            </el-button>
                          </div>
                        </div>
                      </el-form>

                      <el-form size="small" v-if="active===2" class='col-sm-12'>
                        <el-form-item
                          label="การให้บริการเสริม (ที่คิดค่าใช้บริการ)"
                        ></el-form-item>
                        <el-form-item label="บริการความบันเทิง Contents (ภาษาไทย)" prop="content_service">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.content_service_th"></el-input>
                        </el-form-item>
                        <el-form-item label="บริการความบันเทิง Contents (ภาษาอังกฤษ) " prop="content_service">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.content_service_en"></el-input>
                        </el-form-item>
                        <el-form-item label="บริการโทรศัพท์เคลื่อนที่ (ภาษาไทย)" prop="mobile_service">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.mobile_service_th"></el-input>
                        </el-form-item>
                        <el-form-item label="บริการโทรศัพท์เคลื่อนที่ (ภาษาอังกฤษ)" prop="mobile_service">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.mobile_service_en"></el-input>
                        </el-form-item>
                        <el-form-item label="บริการ WiFi/Hotspot (ภาษาไทย)" prop="wifi_service">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.wifi_service_th"></el-input>
                        </el-form-item>
                        <el-form-item label="บริการ WiFi/Hotspot (ภาษาอังกฤษ)" prop="wifi_service">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.wifi_service_en"></el-input>
                        </el-form-item>
                        <el-form-item label="บริการ Fixed Line (ภาษาไทย)" prop="fixed_line_service">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.fixed_line_service_th"></el-input>
                        </el-form-item>
                        <el-form-item label="บริการ Fixed Line (ภาษาอังกฤษ)" prop="fixed_line_service">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.fixed_line_service_en"></el-input>
                        </el-form-item>
                        <el-form-item label="บริการอุปกรณ์อื่นๆ (ภาษาไทย)">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.device_service_th"></el-input>
                        </el-form-item>
                        <el-form-item label="บริการอุปกรณ์อื่นๆ (ภาษาอังกฤษ)">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.device_service_en"></el-input>
                        </el-form-item>
                        <el-form-item label="การให้บริการอื่นๆ (ภาษาไทย)" prop="other_service">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.other_service_th"></el-input>
                        </el-form-item>
                        <el-form-item label="การให้บริการอื่นๆ (ภาษาอังกฤษ)" prop="other_service">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.other_service_en"></el-input>
                        </el-form-item>
                          <div class="col-xs-12" style="padding-bottom: 20px !important">
                            <div class="col-xs-3">
                              <el-button round
                                type="primary"
                                class="pull-left"
                                @click="back()"
                              >
                                <i class="el-icon-back"></i>
                              </el-button>
                            </div>
                            <div class="col-xs-2"> </div>
                            <div class="col-xs-2">
                              <el-button
                                type="success"
                                @click="preview()"
                                >
                                บันทึก
                              </el-button>
                            </div>
                            <div class="col-xs-2"></div>
                            <div class="col-xs-3">
                              <el-button round
                                type="primary"
                                class="pull-right"
                                @click="next()"
                                >
                                <i class="el-icon-right"></i>
                              </el-button>
                            </div>
                          </div>
                      </el-form>
                    </el-form>
                    <el-form size="small" v-if="active===3" class='col-sm-12'>
                      <el-form-item label="สิทธิพิเศษ (ที่ไม่มีค่าใช้บริการ)"></el-form-item>
                      <el-form-item label="บริการความบันเทิง Contents (ภาษาไทย)">
                        <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_content_th"></el-input>
                      </el-form-item>
                      <el-form-item label="บริการความบันเทิง Contents (ภาษาอังกฤษ)">
                        <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_content_en"></el-input>
                      </el-form-item>
                      <el-form-item label="บริการโทรศัพท์เคลื่อนที่ (ภาษาไทย)">
                        <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_mobile_th"></el-input>
                      </el-form-item>
                      <el-form-item label="บริการโทรศัพท์เคลื่อนที่ (ภาษาอังกฤษ)">
                        <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_mobile_en"></el-input>
                      </el-form-item>
                      <el-form-item label="บริการ WiFi (ภาษาไทย)">
                        <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_wifi_th"></el-input>
                      </el-form-item>
                      <el-form-item label="บริการ WiFi (ภาษาอังกฤษ)">
                        <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_wifi_en"></el-input>
                      </el-form-item>
                      <el-form-item label="พรีเมียม (ภาษาไทย)">
                        <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_premium_th"></el-input>
                      </el-form-item>
                      <el-form-item label="พรีเมียม (ภาษาอังกฤษ)">
                        <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_premium_en"></el-input>
                      </el-form-item>
                      <el-form-item label="บริการอุปกรณ์อื่นๆ (ภาษาไทย)">
                        <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_device_th"></el-input>
                      </el-form-item>
                      <el-form-item label="บริการอุปกรณ์อื่นๆ (ภาษาอังกฤษ)">
                        <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_device_en"></el-input>
                      </el-form-item>
                      <el-form-item label="การให้บริการอื่นๆ (ภาษาไทย)">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_other_th"></el-input>
                      </el-form-item>
                      <el-form-item label="การให้บริการอื่นๆ (ภาษาอังกฤษ)">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_other_en"></el-input>
                      </el-form-item>
                      <div class="col-xs-12" style="padding-bottom: 20px !important">
                        <div class="col-xs-3">
                          <el-button round
                            type="primary"
                            class="pull-left"
                            @click="back()"
                          >
                            <i class="el-icon-back"></i>
                          </el-button>
                        </div>
                        <div class="col-xs-2"> </div>
                        <div class="col-xs-2">
                          <el-button
                            type="success"
                            @click="preview()"
                            >
                            บันทึก
                          </el-button>
                        </div>
                        <div class="col-xs-2"></div>
                        <div class="col-xs-3">
                          <el-button round
                            type="primary"
                            class="pull-right"
                            @click="next()"
                            >
                            <i class="el-icon-right"></i>
                          </el-button>
                        </div>
                      </div>
                      </el-form>
                      <el-form size="small" v-if="active===4" class='col-sm-12'>
                        <div class="row">
                          <div class="col-sm-6">
                            <el-form-item label="อัตราค่าบริการอินเทอร์เน็ตต่อหน่วย (บาท/Mbps)">
                              <el-input-number v-model="form.internet_per_Mbps" :min="null" :max="999" :precision="10" style="width: 400px"></el-input-number>
                            </el-form-item>
                          </div>
                        </div>
                        <el-form-item label="ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาไทย)">
                          <el-input type="textarea"
                                    maxlength="500"
                                    show-word-limit
                                    :autosize="{ minRows: 4, maxRows: 4}"
                                    v-model="form.promotion_condition_th"></el-input>
                        </el-form-item>
                        <el-form-item label="ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาอังกฤษ)">
                          <el-input type="textarea"
                                    maxlength="500"
                                    show-word-limit
                                    :autosize="{ minRows: 4, maxRows: 4}"
                                    v-model="form.promotion_condition_en"></el-input>
                        </el-form-item>
                        <el-form-item label="ลิงก์เว็บไซต์ หรือลิงก์รายการส่งเสริมการขายของผู้ให้บริการ">
                          <el-input clearable v-model="form.promotion_link_url"></el-input>
                        </el-form-item>
                        <el-form-item label="ลิงก์รูปโฆษณา หรือรูปรายการส่งเสริมการขาย">
                          <el-input clearable v-model="form.promotion_banner"></el-input>
                        </el-form-item>
                        <div class="col-xs-12" style="padding-bottom: 20px !important">
                          <div class="col-xs-3">
                            <el-button round
                              type="primary"
                              class="pull-left"
                              @click="back()"
                            >
                              <i class="el-icon-back"></i>
                            </el-button>
                          </div>
                          <div class="col-xs-2"> </div>
                          <div class="col-xs-2">
                            <el-button
                              type="success"
                              @click="preview()"
                              >
                              บันทึก
                            </el-button>
                          </div>
                          <div class="col-xs-2"></div>
                          <div class="col-xs-3"></div>
                        </div>
                      </el-form>
                    <el-dialog title="การร้องขอแก้ไขข้อมูล" :visible.sync="dialogPreview" :width="'80%'">
                      <el-table :data="dialogTable">
                        <el-table-column prop="name" label="หัวข้อ"></el-table-column>
                        <el-table-column prop="old" label="ข้อมูลเดิม"></el-table-column>
                        <el-table-column prop="new" label="ข้อมูลใหม่"></el-table-column>
                      </el-table>
                      <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogPreview = false">แก้ไขเพิ่มเติม</el-button>
                        <el-button type="success" @click="save()">ส่งคำร้องขอแก้ไข</el-button>
                      </span>
                    </el-dialog>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<style>
  .btn-step :hover {
    cursor: pointer;
    color:#3c8dbc !important
  }
</style>
<script>
import { mapState,mapActions } from "vuex"
import moment from 'moment';
export default {
  data() {
    return {
      label_position: "top",
      active: 0,
      old_name: null,
      form: {},
      dueDatePickerOptions: {
          disabledDate: this.disabledDueDate
      },
      rules: {},
      dialogPreview : false,
      dialogTable : []
    };
  },
  computed: {
    ...mapState({
      store_provider_id : store => store.Manage_internet.provider_id,
      store_admin_id : store => store.Manage_internet.user_id,
      details : store => store.Manage_internet.details,
      schema_th : store => store.Manage_request.broadband_schema_th,
      schema_en : store => store.Manage_request.broadband_schema_en
    })
  },
  created(){
    this.$store.dispatch('Manage_internet/get_provider_id')
  },
  mounted(){
    if(this.details){
      this.form = Object.assign({},this.details)
    }else{
      const regex = /Operator/;
      let path = regex.test(this.$router.currentRoute.path) ? 'Operator_Manage_internet' : 'Manage_internet'
      this.$router.push({ name: path })
    } 
  },
  methods: {
    ...mapActions({
      addBroadbandEditRevision: "Manage_request/addBroadbandEditRevision",
      get_id: "Manage_internet/get_provider_id"
    }),
    next() {
      this.steps(1+this.active)
    },
    back() {
      this.steps(0+this.active-1)
    },
    save() {
      this.form.created_promotion_from = "cms"
      this.addBroadbandEditRevision(this.form)
    },
    validate: function(page){
      let pass = false;
      switch (page) {
        case 0:
          if(this.form.promotion_code == '') {
            this.$confirm("กรุณากรอกรหัสรายการส่งเสริมการขาย", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if(this.form.promotion_name_th == '') {
            this.$confirm("กรุณากรอกชื่อรายการส่งเสริมการขาย (ภาษาไทย)", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if(this.form.promotion_technology == '') {
            this.$confirm("กรุณาเลือกประเภทเทคโนโลยีของการให้บริการ", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if(this.form.promotion_type == '') {
            this.$confirm("กรุณาเลือกชนิดของรายการส่งเสริมการขาย", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if((this.form.start_sale_date == '') || (this.form.start_sale_date == null)) {
            this.$confirm("กรุณาเลือกวันที่เสนอขาย", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if((this.form.end_sale_date != null) && (this.form.start_sale_date >= this.form.end_sale_date)) {
            this.$confirm("วันที่สิ้นสุดการเสนอขาย ต้องมากกว่าวันที่เสนอขาย", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if((this.form.start_service_date == '') || (this.form.start_service_date == null)) {
            this.$confirm("กรุณาเลือกวันที่ให้บริการ", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if((this.form.end_service_date != null) && (this.form.start_service_date >= this.form.end_service_date)) {
            this.$confirm("วันที่สิ้นสุดการให้บริการต้องมากกว่า วันที่ให้บริการ", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if(this.form.promotion_type == 'main' && !this.form.promotion_price) {
            this.$confirm("กรุณากรอกค่าบริการเหมาจ่ายรวมตามสิทธิการใช้งาน (บาท)", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else {
            pass = true;
          }
          break;
        case 1:
          if(this.form.promotion_type == 'main' && !this.form.download_speed) {
            this.$confirm("กรุณากรอกความเร็วในการดาวน์โหลด", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if(this.form.promotion_type == 'main' && !this.form.upload_speed) {
            this.$confirm("กรุณากรอกความเร็วในการอัปโหลด", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else {
            pass = true;
          }
          break;
        case 2:
          pass = true;
          break;
        case 3:
          pass = true;
          break;
        case 4:
          pass = true;
          break;
        default:
          return false
      }
      return pass
    },
    steps(number){
      let temp = this.active
      let going_page = number
      if (temp < number){
        for(let page = temp; page < number; page++){
          if(!this.validate(page)) {
            going_page = page
            break;
          }
        }
        this.active = going_page
      } else {
        this.active = going_page
      }
    },
    preview(){
      if(!this.validate(this.active)){
        return false
      }
      this.dialogTable = []
      for(let key of this.schema_en){
        if(this.form[key] != this.details[key]){
          let old_item = this.details[key]
          let new_item = this.form[key]
              old_item = ['start_sale_date','end_sale_date','start_service_date','end_service_date'].includes(key) && old_item
                      ? old_item = moment(old_item).add(543,'Y').format('DD/MM/YYYY') : old_item
              new_item = ['start_sale_date','end_sale_date','start_service_date','end_service_date'].includes(key) && new_item
                      ? new_item = moment(new_item).add(543,'Y').format('DD/MM/YYYY') : new_item
          this.dialogTable.push({
            name : this.schema_th[this.schema_en.indexOf(key)],
            old : old_item,
            new : new_item
          })
        }
      }
      if(!this.dialogTable.length){
        this.$confirm("ไม่พบการเปลี่ยนแปลงข้อมูล ต้องการยกเลิกการเปลี่ยนแปลงหรือไม่", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ย้อนกลับ",
          showCancelButton: true,
          type: "warning"
        }).then(() => {
          this.$router.push({name : 'Operator_Manage_internet'});
        }).catch(() =>{})
      }else{
        this.dialogPreview = true
      }
    }
  }
};
</script>
